interface PromoDisplayTextByCode {
  [code: string]: string | undefined
}

export const textForWellWorldCodes: PromoDisplayTextByCode = {
  WW5: '5% Off Well World Discount',
  WW10: '10% Off Well World Discount',
  WW15: '15% Off Well World Discount',
  WW20: '20% Off Well World Discount',
  WW25: '25% Off Well World Discount',
  WW30: '30% Off Well World Discount',
  WW35: '35% Off Well World Discount',
  WW40: '40% Off Well World Discount',
}

export const textForAutoShipCodes: PromoDisplayTextByCode = {
  AUTOSHIPANDSAVENOW: 'Auto-Ship & Save 5%',
}

export const restrictedFromUIInputCodes: string[] = [] // WW codes not restricted for now
